/**
 * Generated from LightsOutElmoBathroomLayout.fla
 */
export function LightsOutElmoBathroomLayout(this: ILightsOutElmoBathroomLayout) {
	const bg = this.bg;
	LightsOutElmoBathroomLayout_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const shelf = this.shelf;
	LightsOutElmoBathroomLayout_shelf.call(this.shelf);
	shelf.x = 626.5;
	shelf.y = 268;
	shelf.width = 149.50;
	shelf.height = 196.00;
	if (shelf.onLayout) shelf.onLayout();
	const lightswitch = this.lightswitch;
	LightsOutElmoBathroomLayout_lightswitch.call(this.lightswitch);
	lightswitch.x = 919.5;
	lightswitch.y = 264.75;
	lightswitch.width = 29.00;
	lightswitch.height = 49.50;
	if (lightswitch.onLayout) lightswitch.onLayout();
	const toothbrush = this.toothbrush;
	LightsOutElmoBathroomLayout_toothbrush.call(this.toothbrush);
	toothbrush.x = 964.75;
	toothbrush.y = 371.75;
	toothbrush.width = 18.50;
	toothbrush.height = 80.50;
	if (toothbrush.onLayout) toothbrush.onLayout();
	const sink = this.sink;
	LightsOutElmoBathroomLayout_sink.call(this.sink);
	sink.x = 808.5;
	sink.y = 467.5;
	sink.width = 206.00;
	sink.height = 271.00;
	if (sink.onLayout) sink.onLayout();
	const soap = this.soap;
	LightsOutElmoBathroomLayout_soap.call(this.soap);
	soap.x = 729.5;
	soap.y = 386;
	soap.width = 39.00;
	soap.height = 30.00;
	if (soap.onLayout) soap.onLayout();
	const radio = this.radio;
	LightsOutElmoBathroomLayout_radio.call(this.radio);
	radio.x = 1071;
	radio.y = 369.75;
	radio.width = 116.00;
	radio.height = 84.50;
	if (radio.onLayout) radio.onLayout();
	const lights = this.lights;
	LightsOutElmoBathroomLayout_lights.call(this.lights);
	lights.x = 804.25;
	lights.y = 95;
	lights.width = 198.50;
	lights.height = 53.00;
	if (lights.onLayout) lights.onLayout();
	const picture = this.picture;
	LightsOutElmoBathroomLayout_picture.call(this.picture);
	picture.x = 1010.75;
	picture.y = 149.75;
	picture.width = 141.50;
	picture.height = 111.50;
	if (picture.onLayout) picture.onLayout();
	const stool = this.stool;
	LightsOutElmoBathroomLayout_stool.call(this.stool);
	stool.x = 805.75;
	stool.y = 614.75;
	stool.width = 176.50;
	stool.height = 111.50;
	if (stool.onLayout) stool.onLayout();
	const nightlight = this.nightlight;
	LightsOutElmoBathroomLayout_nightlight.call(this.nightlight);
	nightlight.x = 1116.25;
	nightlight.y = 247.5;
	nightlight.width = 40.50;
	nightlight.height = 89.00;
	if (nightlight.onLayout) nightlight.onLayout();
	const glowtoy = this.glowtoy;
	LightsOutElmoBathroomLayout_glowtoy.call(this.glowtoy);
	glowtoy.x = 1206.25;
	glowtoy.y = 594;
	glowtoy.width = 120.50;
	glowtoy.height = 92.00;
	if (glowtoy.onLayout) glowtoy.onLayout();
	const nightlightGlow = this.nightlightGlow;
	LightsOutElmoBathroomLayout_nightlightGlow.call(this.nightlightGlow);
	nightlightGlow.x = 1116.3;
	nightlightGlow.y = 223.5;
	nightlightGlow.width = 47.50;
	nightlightGlow.height = 55.00;
	if (nightlightGlow.onLayout) nightlightGlow.onLayout();
	const lightsGlow = this.lightsGlow;
	LightsOutElmoBathroomLayout_lightsGlow.call(this.lightsGlow);
	lightsGlow.x = 808.4;
	lightsGlow.y = 86.35;
	lightsGlow.width = 194.00;
	lightsGlow.height = 56.50;
	if (lightsGlow.onLayout) lightsGlow.onLayout();
	const elmo = this.elmo;
	LightsOutElmoBathroomLayout_elmo.call(this.elmo);
	elmo.x = 559.5;
	elmo.y = 683;
	elmo.width = 221.00;
	elmo.height = 320.00;
	if (elmo.onLayout) elmo.onLayout();
	const homeButton = this.homeButton;
	LightsOutElmoBathroomLayout_homeButton.call(this.homeButton);
	homeButton.x = 428;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	return this;
}
function LightsOutElmoBathroomLayout_bg(this: ILightsOutElmoBathroomLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("lightsout-bathroom-bg.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_shelf(this: ILightsOutElmoBathroomLayout_shelf) {
	if (this.setLayoutTexture) this.setLayoutTexture("shelf.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_lightswitch(this: ILightsOutElmoBathroomLayout_lightswitch) {
	if (this.setLayoutTexture) this.setLayoutTexture("lightswitch.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_toothbrush(this: ILightsOutElmoBathroomLayout_toothbrush) {
	if (this.setLayoutTexture) this.setLayoutTexture("toothbrush.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_sink(this: ILightsOutElmoBathroomLayout_sink) {
	if (this.setLayoutTexture) this.setLayoutTexture("sink.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_soap(this: ILightsOutElmoBathroomLayout_soap) {
	if (this.setLayoutTexture) this.setLayoutTexture("soap.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_radio(this: ILightsOutElmoBathroomLayout_radio) {
	if (this.setLayoutTexture) this.setLayoutTexture("radio.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_lights(this: ILightsOutElmoBathroomLayout_lights) {
	if (this.setLayoutTexture) this.setLayoutTexture("lights.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_picture(this: ILightsOutElmoBathroomLayout_picture) {
	if (this.setLayoutTexture) this.setLayoutTexture("picture.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_stool(this: ILightsOutElmoBathroomLayout_stool) {
	if (this.setLayoutTexture) this.setLayoutTexture("bathroom-stool.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_nightlight(this: ILightsOutElmoBathroomLayout_nightlight) {
	if (this.setLayoutTexture) this.setLayoutTexture("nightlight.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_glowtoy(this: ILightsOutElmoBathroomLayout_glowtoy) {
	if (this.setLayoutTexture) this.setLayoutTexture("glow-toy.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_nightlightGlow(this: ILightsOutElmoBathroomLayout_nightlightGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("nightlight-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_lightsGlow(this: ILightsOutElmoBathroomLayout_lightsGlow) {
	if (this.setLayoutTexture) this.setLayoutTexture("lights-on-glow.png", 0.500, 0.500);
	return this;
}
function LightsOutElmoBathroomLayout_elmo(this: ILightsOutElmoBathroomLayout_elmo) {
	if (this.setLayoutTexture) this.setLayoutTexture("Elmo.png", 0.502, 1.000);
	return this;
}
function LightsOutElmoBathroomLayout_homeButton(this: ILightsOutElmoBathroomLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
interface ILightsOutElmoBathroomLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ILightsOutElmoBathroomLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ILightsOutElmoBathroomLayoutSprite extends ILightsOutElmoBathroomLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ILightsOutElmoBathroomLayoutText extends ILightsOutElmoBathroomLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ILightsOutElmoBathroomLayoutPolygon extends Array<number> {
}
interface ILightsOutElmoBathroomLayout {
	readonly bg: ILightsOutElmoBathroomLayout_bg;
	readonly shelf: ILightsOutElmoBathroomLayout_shelf;
	readonly lightswitch: ILightsOutElmoBathroomLayout_lightswitch;
	readonly toothbrush: ILightsOutElmoBathroomLayout_toothbrush;
	readonly sink: ILightsOutElmoBathroomLayout_sink;
	readonly soap: ILightsOutElmoBathroomLayout_soap;
	readonly radio: ILightsOutElmoBathroomLayout_radio;
	readonly lights: ILightsOutElmoBathroomLayout_lights;
	readonly picture: ILightsOutElmoBathroomLayout_picture;
	readonly stool: ILightsOutElmoBathroomLayout_stool;
	readonly nightlight: ILightsOutElmoBathroomLayout_nightlight;
	readonly glowtoy: ILightsOutElmoBathroomLayout_glowtoy;
	readonly nightlightGlow: ILightsOutElmoBathroomLayout_nightlightGlow;
	readonly lightsGlow: ILightsOutElmoBathroomLayout_lightsGlow;
	readonly elmo: ILightsOutElmoBathroomLayout_elmo;
	readonly homeButton: ILightsOutElmoBathroomLayout_homeButton;
}
interface ILightsOutElmoBathroomLayout_bg extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_shelf extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_lightswitch extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_toothbrush extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_sink extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_soap extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_radio extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_lights extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_picture extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_stool extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_nightlight extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_glowtoy extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_nightlightGlow extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_lightsGlow extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_elmo extends ILightsOutElmoBathroomLayoutSprite {
}
interface ILightsOutElmoBathroomLayout_homeButton extends ILightsOutElmoBathroomLayoutSprite {
}
